<template>
  <nav class="main-nav">
    <div class="main-nav__menu">
      <div v-for="item in enabledLinks" class="main-nav__item" @click="onLinkClick(item.href)">
        <router-link :id="`nav-${item.name}`" :class="classModifier(item.name)" :to="item.href">
          {{ item.title.toString() }}
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script src="./app-main-nav.js"></script>
<style src="./app-main-nav.scss" lang="scss"></style>
